import $ = require("jquery");
import ol = require("ol");

export class WmsGetCapabilitiesConverter {

    static about = `Uses ol.format.WMSCapabilities to convert xml to an object`;

    static convert(xml: XMLDocument) {
        var wms = new ol.format.WMSCapabilities();
        var caps = <ogc.wms.Wms><any>wms.read(xml);
        return caps;
    }
}

export class WmsDescribeLayerConverter {

    static about = `Extracts typeName from a layer description`;

    static convert(xml: XMLDocument) {
        var $xml = $(xml);

        var result = [];

        $xml.find("LayerDescription").find("Query").each((i, e) => {
            result.push(e.getAttribute("typeName"));
        });

        return result;
    }
}

export class WmsGetFeatureInfoConverter {

    static about = `Uses ol.format.WMSGetFeatureInfo to convert xml to an object`;

    static convert(xml: XMLDocument) {
        var wms = new ol.format.WMSGetFeatureInfo();
        var caps = wms.readFeatureFromDocument(xml);
        return caps;
    }
}

